import { render, staticRenderFns } from "./DashboardIndicador.vue?vue&type=template&id=406f1d4e&scoped=true&"
import script from "./DashboardIndicador.vue?vue&type=script&lang=js&"
export * from "./DashboardIndicador.vue?vue&type=script&lang=js&"
import style0 from "./DashboardIndicador.vue?vue&type=style&index=0&id=406f1d4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406f1d4e",
  null
  
)

export default component.exports